import { jsxs, jsx } from "react/jsx-runtime";
import { CountUp } from "../../chunks/index.js";
import { Carousel } from "react-responsive-carousel";
import { Logo } from "../../chunks/logo.js";
import { getCustomLogoConfigFromURL } from "../../chunks/logo.config.js";
import './fundraising-event.overlay.css';const FundraisingEventOverlay = ({
  eventName,
  goalAmount,
  currentAmount,
  className,
  customLogoURL,
  logoAnimationEnabled = false
}) => {
  const overallProgress = Math.round(100 * (currentAmount / goalAmount));
  const thermInnerClassName = overallProgress <= 0 ? "therm-inner no-point" : "therm-inner point";
  const eventClassName = `event-name ${eventName.length > 25 ? " long" : ""}`;
  const thermStyle = {
    width: `${overallProgress}%`
  };
  return /* @__PURE__ */ jsxs("div", { className: className ? `total-overlay ${className}` : "total-overlay", children: [
    /* @__PURE__ */ jsxs("div", { className: "top-container", children: [
      /* @__PURE__ */ jsx(
        Logo,
        {
          customLogoHeight: 50,
          customLogoURL,
          customLogoWidth: 50,
          logoAnimationEnabled: !!customLogoURL || logoAnimationEnabled
        }
      ),
      /* @__PURE__ */ jsxs(
        Carousel,
        {
          autoPlay: true,
          infiniteLoop: true,
          axis: "vertical",
          interval: 1e4,
          showArrows: false,
          showIndicators: false,
          showStatus: false,
          showThumbs: false,
          children: [
            /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs("div", { className: "therm-raised", children: [
              /* @__PURE__ */ jsx(
                CountUp,
                {
                  preserveValue: true,
                  decimals: 2,
                  duration: 1,
                  end: currentAmount,
                  prefix: "$",
                  separator: ",",
                  useEasing: false
                }
              ),
              " ",
              "Raised"
            ] }) }),
            /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("div", { className: eventClassName, children: eventName }) })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ jsx("div", { className: "bottom-container", children: /* @__PURE__ */ jsx("div", { className: "container", children: /* @__PURE__ */ jsx("div", { className: "therm-container", children: /* @__PURE__ */ jsx("div", { className: thermInnerClassName, style: thermStyle }) }) }) })
  ] });
};
function getFundraisingEventConfigFromURL(url) {
  return {
    ...getCustomLogoConfigFromURL(url)
  };
}
export {
  FundraisingEventOverlay,
  getFundraisingEventConfigFromURL
};
//# sourceMappingURL=fundraising-event.overlay.js.map
